var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComapareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-bar-chart-2835073 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26 23.832H0V24.9154H26V23.832Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24976 0.541667C3.24976 0.242667 3.49242 0 3.79142 0C4.82926 0 7.08692 0 8.12476 0C8.42376 0 8.66642 0.242667 8.66642 0.541667C8.66642 4.11179 8.66642 24.1215 8.66642 24.1215H3.24976V0.541667Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88965 7.67188H10.7183C11.0173 7.67188 11.26 7.91725 11.26 8.22004V24.1185H8.88965V7.67188Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6248 7.13346C14.6248 6.83446 14.8674 6.5918 15.1664 6.5918C16.2043 6.5918 18.4619 6.5918 19.4998 6.5918C19.7988 6.5918 20.0414 6.83446 20.0414 7.13346C20.0414 10.0877 20.0414 24.1207 20.0414 24.1207H14.6248V7.13346Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 6.4069V3.83723C17.3333 3.53444 17.5759 3.28906 17.8749 3.28906C18.9128 3.28906 21.1704 3.28906 22.2083 3.28906C22.5073 3.28906 22.7499 3.53444 22.7499 3.83723V24.121H20.2566V6.95506C20.2566 6.65227 20.014 6.4069 19.715 6.4069H17.3333Z",
    fill: "#414042"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComapareIcon);
export default __webpack_public_path__ + "static/media/comapare-icon.7721e5acc75964b760a407f9291a5021.svg";
export { ForwardRef as ReactComponent };